// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1H2Q9","requiredAsterisk":"Info_requiredAsterisk__3XOOA"};